<app-navbar title="Relatórios e Análises - Cohort" />

<div class="py-8 px-4 overflow-y-auto max-h-[calc(100vh-5rem)] scrollbar-hide">
  <p-tabs value="cohort-clients-depositors">
    <p-tablist class="px-8">
      <p-tab value="cohort-clients-depositors">
        Clientes Depositantes
      </p-tab>
      <p-tab value="cohort-clients-retention">
        Retenção de Clientes
      </p-tab>
      <p-tab value="cohort-clients-bettors">
        Clientes Apostadores
      </p-tab>
      <p-tab value="cohort-bets">
        Turnover
      </p-tab>
      <p-tab value="cohort-ggr">
        GGR
      </p-tab>
      <p-tab value="cohort-deposits">
        Depósitos
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="cohort-clients-depositors">
        <app-cohort-clients-depositors [financialBrandUtmSourceData]="financialBrandUtmSourceData()" />
      </p-tabpanel>

      <p-tabpanel value="cohort-clients-retention">
        <app-cohort-clients-retention [financialBrandUtmSourceData]="financialBrandUtmSourceData()" />
      </p-tabpanel>

      <p-tabpanel value="cohort-clients-bettors">
        <app-cohort-clients-bettors [financialBrandUtmSourceData]="financialBrandUtmSourceData()" />
      </p-tabpanel>

      <p-tabpanel value="cohort-bets">
        <app-cohort-bets [financialBrandUtmSourceData]="financialBrandUtmSourceData()" />
      </p-tabpanel>

      <p-tabpanel value="cohort-ggr">
        <app-cohort-ggr [financialBrandUtmSourceData]="financialBrandUtmSourceData()" />
      </p-tabpanel>

      <p-tabpanel value="cohort-deposits">
        <app-cohort-deposits [financialBrandUtmSourceData]="financialBrandUtmSourceData()" />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
